import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useItem, useItemLostInTransit } from '@/hooks/item';
import { ItemLostInTransitModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemLostInTransitModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;
  const itemR = useItem(item.productId, false);
  const submitR = useItemLostInTransit(item.productId);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      itemR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_lost_in_transit.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.item_lost_in_transit.title')}
        onClose={onClose}
      />
    );
  }

  const body =
    submitR.kind === 'Loading' ? (
      <LoadingBodyModal height={40} />
    ) : (
      <div className={styles.flex100}>
        <div className={styles.height1rem} />
        <div className={styles.text1rem}>{`${t('modal.item_lost_in_transit.item')} #${item.productId}`}</div>
        <div className={styles.height1rem} />
        <div className={styles.text1rem}>{t('modal.item_lost_in_transit.body')} </div>
      </div>
    );

  return (
    <StandardModal
      title={t('modal.item_lost_in_transit.title')}
      onClose={onClose}
      onSubmit={submitR.mutate}
      closeLabel={t('common.no').toUpperCase()}
      submitLabel={t('common.yes').toUpperCase()}
      submittable={submitR.kind !== 'Loading'}
      body={body}
      containerStyle={{ width: 550 }}
      modalName="item_lost_in_transit"
    />
  );
};

export default View;
